import { getWaybillTitlePrices } from "helpers/waybillTitlePrices";

/** Download the operator's source XML without requiring a signing certificate. */
export const getTitleFilePrices = async (accessUrlLink: string) => {
    const response = await fetch(accessUrlLink);
    if (!response.ok) {
        throw new Error("Не удалось загрузить файл титула");
    }
    return getWaybillTitlePrices(new TextDecoder("windows-1251").decode(await response.arrayBuffer()));
};
